import { VipTaskItemTypesEnum } from '@shared/constants';

import { VipTaskItemFormValues } from '../VipSettingsForms';

export const getVipTaskItemSpecificFieldsValue = (values: VipTaskItemFormValues) => {
  const { type, userIdentifierType, joinedTournamentsStartDate, joinedTournamentsCount, completedTasksCount } = values;

  return {
    userIdentifierType: type === VipTaskItemTypesEnum.VALIDATE_PARTNER_ACTION ? userIdentifierType : undefined,
    joinedTournamentsStartDate:
      type === VipTaskItemTypesEnum.JOIN_TOURNAMENTS ? joinedTournamentsStartDate.format() : undefined,
    joinedTournamentsCount: type === VipTaskItemTypesEnum.JOIN_TOURNAMENTS ? joinedTournamentsCount : undefined,
    completedTasksCount: type === VipTaskItemTypesEnum.COMPLETE_TASKS ? completedTasksCount : undefined,
  };
};
